const RUBLES = new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB', minimumFractionDigits: 2 })

/**
 * Сумма в одном из трёх видов входа: целые копейки, рубли числом (прайс 1С, аналитика) или десятичная строка «123.45» от сервера.
 * Вид указан явно, чтобы копейки не принять за рубли.
 */
export type MoneyAmount = { kopecks: number } | { rubles: number | null | undefined } | { decimal: string | null | undefined }

/**
 * Единственный форматировщик денег клиента (CLAUDE.md §7: деньги — одной утилитой, `toFixed` вне неё запрещён): «1 092,07 ₽»,
 * минус всегда «-». Целые копейки не делятся с плавающей точкой до показа; рубли и строка округляются до копеек. Пустое значение
 * (`null`, `undefined`, не число) возвращает `empty` — прочерк, а не «0,00 ₽»; для строки `empty` по умолчанию — исходный текст
 * там, где он не число, поэтому пустую цену словами задаёт вызывающий.
 */
export function formatAmount(amount: MoneyAmount, empty = '—'): string {
  let kopecks: number
  if ('kopecks' in amount) kopecks = amount.kopecks
  else if ('rubles' in amount) {
    if (amount.rubles === null || amount.rubles === undefined) return empty
    kopecks = Math.round(amount.rubles * 100)
  } else {
    if (amount.decimal === null || amount.decimal === undefined) return empty
    const value = Number(amount.decimal)
    if (!Number.isFinite(value)) return amount.decimal
    kopecks = Math.round(value * 100)
  }
  if (!Number.isFinite(kopecks)) return empty
  const sign = kopecks < 0 ? '-' : ''
  const absolute = Math.abs(Math.trunc(kopecks))
  const rubles = Math.trunc(absolute / 100)
  const rest = String(absolute % 100).padStart(2, '0')
  return sign + RUBLES.format(Number(`${rubles}.${rest}`))
}

/** Сумма из целых копеек: «1 092,07 ₽». */
export const formatKopecks = (kopecks: number): string => formatAmount({ kopecks })
